/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoringDeviceNested,
    ReadOnlyMonitoringDeviceNestedFromJSON,
    ReadOnlyMonitoringDeviceNestedFromJSONTyped,
    ReadOnlyMonitoringDeviceNestedToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20035
 */
export interface InlineResponse20035 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20035
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20035
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20035
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoringDeviceNested>}
     * @memberof InlineResponse20035
     */
    results: Array<ReadOnlyMonitoringDeviceNested>;
}

export function InlineResponse20035FromJSON(json: any): InlineResponse20035 {
    return InlineResponse20035FromJSONTyped(json, false);
}

export function InlineResponse20035FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20035 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoringDeviceNestedFromJSON)),
    };
}

export function InlineResponse20035ToJSON(value?: InlineResponse20035 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoringDeviceNestedToJSON)),
    };
}


